import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import RestClient from 'yoda-interfaces/lib/RestClient/RestClient';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import { catIdRedirect } from '../configurations/config';
import { getDeviceType, getContentDate, getURLParameterBykey, getPageType } from '../utils';

// setting preview env parameters (see MNPYGD-2268)
export const getPreviewParams = (
    context = {},
    __SERVER__,
    initialLoad,
    loc = {},
    enableDefaultFilterForPreview
) => {
    let params = {};
    const urlStatus = getURLParameterBykey('item_status', loc.search);
    const facetId = getURLParameterBykey('activeFacetId', loc.search);
    if (!__SERVER__ && context.isPreview) {
        params = {
            channel: getDeviceType((context && context.deviceType) || {}),
            contentDate: getContentDate(),
        };
    }

    // added default preview param see MNPYGD-2946
    if (
        initialLoad &&
        !urlStatus &&
        context.isPreview &&
        enableDefaultFilterForPreview &&
        facetId !== '44710'
    ) {
        params = { ...params, item_status: 1 };
    }
    return params;
};

export const getAbTestParams = (featureFlags) => {
    let payload = [];
    const enableABTest = _get(featureFlags, 'enableABTest', false);
    if (!__SERVER__ && enableABTest && getPageType() === 'g') {
        const pageURL = _get(window.location, 'href', '');
        const referrerURL = _get(window.location, 'origin', '');
        payload = [
            {
                pageURL,
                referrerURL,
            },
        ];
        return payload;
    }
    return {};
};

export const loadGalleryDetails = (loc, actions, initialLoad, AMPpage, featureFlags = {}) => {
    if (loc) {
        const abTestParams = getAbTestParams(featureFlags);
        const enableDefaultFilterForPreview = _get(featureFlags, 'enableDefaultFilterForPreview');
        const query = makeQuery(loc.search);
        const params = {
            ...query,
            ...getPreviewParams(
                RestClient.getContext(),
                __SERVER__,
                initialLoad,
                loc,
                enableDefaultFilterForPreview
            ),
        };
        let apiPath;

        if (query.id && loc.pathname.match(catIdRedirect.pattern)) {
            // Old Cat Id Url. We have to perform a 301 to new url
            apiPath = catIdRedirect.apiPath; // eslint-disable-line
            params.id = query.id;
        } else {
            apiPath = loc.pathname.substr(1);
        }
        actions.getGalleryDetailsById({
            loc,
            params,
            apiPath,
            initialLoad,
            AMPpage,
            abTestParams,
        });
    }
};

/* istanbul ignore next */
export const normalizeSelectedFilters = (obj) => {
    const selectedFacets = [];
    // eslint-disable-next-line
    for (const category of obj) {
        // eslint-disable-next-line
        for (const facet of category.facetValueList) {
            facet.category = category.facetName;
            selectedFacets.push(facet);
        }
    }
    return selectedFacets;
};

export const matchMediaQuery = (query) => !__SERVER__ && window && window.matchMedia(query).matches;

export const getListItemsPerRow = (deviceType = {}) => {
    let itemsPerRow = 3;
    if (matchMediaQuery('(min-width: 1330px)')) {
        itemsPerRow = 4;
    } else if (matchMediaQuery('(max-width: 600px)')) {
        itemsPerRow = 2;
    }
    if (deviceType.isTablet) {
        itemsPerRow = 4;
    }
    return itemsPerRow;
};

// istanbul ignore next
export const exposeSkuSwatches = (galleryData) => {
    const { organicZoneInfo: { products } = {} } = galleryData;

    window.getSkuSwatches = function getSkuSwatches() {
        let skuSwatches = [];
        if (!_isEmpty(products)) {
            skuSwatches = products.map(({ ppId, skuSwatch }) => ({ ppId, skuSwatch }));
        }
        return skuSwatches;
    };
};

export const hasBreadCrumbLinks = (
    breadCrumbInfo,
    { isBot = false },
    hideBreadCrumbsWhenNoNavigation
) => {
    return !_isEmpty(breadCrumbInfo) && (isBot || !hideBreadCrumbsWhenNoNavigation)
        ? true
        : !_isEmpty(breadCrumbInfo) &&
              breadCrumbInfo.some((el) => {
                  return el.navigationState && el.navigationState.length > 0;
              });
};

export const exposeEnsembleData = (galleryData) => {
    const { organicZoneInfo: { products = [] } = {} } = galleryData;

    window.getEnsembleData = function getEnsembleData() {
        let ensembleData = [];
        if (!_isEmpty(products)) {
            ensembleData = products
                .filter(({ entityType = [] }) => entityType.includes('ENSEMBLE'))
                .map((product) => ({
                    name: product.name,
                    ppId: product.ppId,
                    priceRange: {
                        currentMin: product.currentMin,
                        currentMax: product.currentMax,
                        originalMin: product.originalMin,
                        originalMax: product.originalMax,
                    },
                    imagesInfo: product.imagesInfo,
                    bundleIndicator: product.bundleIndicator,
                    ensembleImageUrls: product.ensembleImageUrls,
                    upperLeftBadge: product.upperLeftBadge,
                }));
        }
        return ensembleData;
    };
};
